import React from 'react';
import { ReactComponent } from 'Common/components/Icons/add-topic.svg';

const AddTopic = () => <ReactComponent className="MuiSvgIcon-root" />;

export default AddTopic;
